export function isFalse(value) {
  return value === false || value === 'false';
}
